export default __webpack_public_path__ + "static/media/instagram-open-in-browser.b0f50197.jpg";